// Mod_TerrainMaterials — the Set9 Phase 7 DB model for procedural materials (plan §5, §6),
// reworked by Set12 (path-driven material assignment).
// Persists, per map (as a modifier on a MapObject, mirroring Mod_TerrainDefinition):
//   - userRecipes: MaterialRecipe[] — user-authored recipes (roots, or extend/fork variants of
//     the built-ins).  The recipe CATALOGUE is populated from these at render time.
//   - materialDefs: ProcMaterialDef[] — placed instances (which recipe + per-instance seed/params).
//   - baseRecipeID: the map-wide fallback material (where no path region applies; Set12 §3.2).
//   - blendDefaults: global blend defaults (per-path feather/featherCurve fall back to these).
//
// Set12 removed the Set9 `assignments` (elevation-band / closed-ring / open-curve / cliff-band
// region rules): material assignment now lives ON the path (`ObjPath.materialFeature` →
// `collectMaterialRegions` → per-chunk signed-distance rasterisation).  The old class
// `TerrainMaterialAssignment` + `TerrainMaterialRule` are deleted (single user re-authors by
// hand via the map-object JSON-editor dialog — plan §6 "Migration"); persisted leftovers are
// tolerated and ignored.
import {
	MaterialRecipe, ProcMaterialDef,
} from "../../../../../Terrain/Materials/@MaterialTypes.js";
import {MaterialBlendDefaults} from "../../../../../Terrain/Materials/@MaterialFeature.js";

export class Mod_TerrainMaterials {
	constructor(data?: Partial<Mod_TerrainMaterials>) { Object.assign(this, data); }

	/** User-authored recipes (roots or extend/fork variants of the built-ins).  Loaded into the
	 *  recipe catalogue at render time; the program cache keyed by resolved structural hash makes
	 *  params-only variants free (D1/D10). */
	userRecipes: MaterialRecipe[] = [];
	/** Placed material instances (recipe + per-instance seed/params). */
	materialDefs: ProcMaterialDef[] = [];
	/** The map-wide fallback material (where no path region applies). Set12 §3.2. */
	baseRecipeID = "dirt";
	/** Global blend defaults (per-path `feather`/`featherCurve` fall back to these). Set12 §3.2. */
	blendDefaults = new MaterialBlendDefaults();
}
